<!-- Awards & Press Section -->
<div>
  <!-- Content -->
  <div class="row justify-content-center text-center d-flex align-items-center">
      <div class="mx-3">
        <img class="max-w-11rem mx-auto my-3" src="../assets/svg/clients-logo/usa-today.svg" alt="Image Description">
      </div>
      <div class="mx-3">
        <img class="max-w-11rem mx-auto my-3" src="../assets/svg/clients-logo/cityscene-logo.svg" alt="Image Description">
      </div>
      <div class="mx-3">
        <a href="https://www.worldtravelawards.com/vote-for-kopa-tours-north-americas-leading-travel-agency-2021" target="_blank" rel="noreferrer">
          <img class="max-w-11rem mx-auto my-3" src="../assets/img/kopa-branding/1x/nominee-shield.png" alt="Image Description">
        </a>
      </div>
      <div class="mx-3">
        <img class="max-w-11rem mx-auto my-3" src="../assets/img/logos/lifney.png" alt="Image Description">
      </div>
      <div class="mx-3">
        <img class="max-w-11rem mx-auto my-3" src="../assets/svg/clients-logo/yahoo.svg" alt="Image Description">
      </div>
  </div>
  <!-- End Content -->
</div>
<!-- End Awards & Press Section -->
